export var APP_SCROLL_CONTAINER_ID = 'officehome-scroll-container';
//# sourceMappingURL=ids.js.map